const typeColors = {
  normal: { bg: '#A8A77A', text: 'dark' }, 
  fire: { bg: '#EE8130', text: 'dark' }, 
  water: { bg: '#6390F0', text: 'dark' }, 
  grass: { bg: '#7AC74C', text: 'dark' }, 
  electric: { bg: '#F7D02C', text: 'dark' }, 
  ice: { bg: '#96D9D6', text: 'dark' }, 
  fighting: { bg: '#C22E28', text: 'light' }, 
  poison: { bg: '#A33EA1', text: 'light' }, 
  ground: { bg: '#E2BF65', text: 'dark' }, 
  flying: { bg: '#A98FF3', text: 'dark' }, 
  psychic: { bg: '#F95587', text: 'light' },
  bug: { bg: '#A6B91A', text: 'dark' },
  rock: { bg: '#B6A136', text: 'dark' }, 
  ghost: { bg: '#735797', text: 'light' }, 
  dragon: { bg: '#6F35FC', text: 'light' }, 
  dark: { bg: '#705746', text: 'light' }, 
  steel: { bg: '#B7B7CE', text: 'dark' }, 
  fairy: { bg: '#D685AD', text: 'dark' }, 
}

export default typeColors
